import { ArrowDownRight, Play } from "lucide-react";

export default function Hero({ onCta, onWatchVideo }) {
  return (
    <section id="top" data-testid="hero-section" className="relative w-full h-[100svh] min-h-[640px] overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="/images/00-anre-l-residence-vista-exterior.jpg"
          alt="ANREÁL Residence — Vista exterior"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/30 to-black/65" />
      </div>

      <div className="relative z-10 h-full max-w-[1400px] mx-auto px-6 lg:px-10 flex flex-col">
        <div className="flex-1" />

        <div className="pb-12 lg:pb-20 max-w-5xl">
          <div data-testid="hero-eyebrow" className="reveal mb-6 lg:mb-8 flex items-center gap-3 text-[#F9F9F6]/85 text-[11px] tracking-[0.32em] uppercase">
            <span className="w-8 h-px bg-[#F9F9F6]/60" />
            <span>Cantanhede</span>
            <span className="w-1 h-1 rounded-full bg-[#F9F9F6]/60" />
            <span>Condomínio Privado</span>
            <span className="hidden sm:inline w-1 h-1 rounded-full bg-[#F9F9F6]/60" />
            <span className="hidden sm:inline">Fase de Lançamento</span>
          </div>

          <h1
            data-testid="hero-title"
            className="reveal font-display text-white font-light text-balance text-[44px] leading-[1.02] sm:text-[64px] lg:text-[96px] tracking-[-0.03em]"
            style={{ transitionDelay: "120ms" }}
          >
            Onde a natureza
            <br className="hidden sm:block" />
            <span className="text-white/95"> e a elegância </span>
            <span className="italic-display text-white"> se encontram.</span>
          </h1>

          <p
            data-testid="hero-subtitle"
            className="reveal mt-6 lg:mt-8 max-w-2xl text-[15px] lg:text-[17px] text-[#F9F9F6]/85 font-light leading-relaxed"
            style={{ transitionDelay: "240ms" }}
          >
            42 apartamentos T0 a T4 com jardins privativos, piscina, court de padel e 4 000m² de jardim — o maior jardim residencial de Cantanhede. Classificação energética A+.
          </p>

          <div className="reveal mt-8 lg:mt-10 flex flex-wrap items-center gap-3 lg:gap-4" style={{ transitionDelay: "360ms" }}>
            <button
              data-testid="hero-cta-primary"
              onClick={onCta}
              className="group inline-flex items-center gap-3 h-12 lg:h-14 px-6 lg:px-8 bg-[#F9F9F6] text-[#1A1A1A] text-[12px] tracking-[0.24em] uppercase hover:-translate-y-[2px] transition-all duration-300"
            >
              Solicitar Informações
              <ArrowDownRight size={18} strokeWidth={1.5} className="transition-transform group-hover:translate-x-1 group-hover:translate-y-1" />
            </button>
            <a
              href="#tipologias"
              data-testid="hero-cta-secondary"
              className="group inline-flex items-center gap-3 h-12 lg:h-14 px-6 lg:px-8 border border-[#F9F9F6]/70 text-[#F9F9F6] text-[12px] tracking-[0.24em] uppercase hover:bg-[#F9F9F6] hover:text-[#1A1A1A] hover:-translate-y-[2px] transition-all duration-300"
            >
              Ver Tipologias
              <ArrowDownRight size={18} strokeWidth={1.5} className="transition-transform group-hover:translate-x-1 group-hover:translate-y-1" />
            </a>
            <a
              href="/anreal-residence-brochura.pdf"
              target="_blank"
              rel="noreferrer"
              data-testid="hero-cta-brochure"
              className="group inline-flex items-center gap-3 h-12 lg:h-14 px-6 lg:px-8 border border-[#F9F9F6]/70 text-[#F9F9F6] text-[12px] tracking-[0.24em] uppercase hover:bg-[#F9F9F6] hover:text-[#1A1A1A] hover:-translate-y-[2px] transition-all duration-300"
            >
              Brochura PDF
              <ArrowDownRight size={18} strokeWidth={1.5} className="transition-transform group-hover:translate-x-1 group-hover:translate-y-1" />
            </a>
            <button
              type="button"
              data-testid="hero-cta-video"
              onClick={onWatchVideo}
              className="group inline-flex items-center gap-3 h-12 lg:h-14 px-6 lg:px-8 border border-[#F9F9F6]/70 text-[#F9F9F6] text-[12px] tracking-[0.24em] uppercase hover:bg-[#F9F9F6] hover:text-[#1A1A1A] hover:-translate-y-[2px] transition-all duration-300"
            >
              <Play size={16} strokeWidth={1.5} className="ml-[-2px]" />
              Ver Vídeo
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
